import { useQuery } from 'react-query';
import {
  calculateProfit,
  CalculateProfitOptions,
} from './calculate-profit-utils';

const useCalculateProfit = ({
  numberOfShares,
  fromDate,
  token,
  enabled = true,
}: CalculateProfitOptions & { enabled?: boolean }) => {
  return useQuery(
    'calculator',
    () =>
      calculateProfit({
        token,
        numberOfShares,
        fromDate,
      }),
    {
      enabled,
      initialStale: true,
      initialData: {
        earnings: undefined,
        returnPercentageIncludingDividends: undefined,
        lastDividendDate: undefined,
        last_dividends: '',
        dividends: undefined,
      },
    },
  );
};

export { useCalculateProfit };
